import api from "./api";

export const transactionDataMap = (item) => {
  return {
    transactionId: item?._id ?? null,
    pocId: item?.poc?._id ?? null,
    pocName: item?.poc?.name ?? null,
    pocaName: item?.poc_attendant?.name ?? null,
    collectorName: item?.collector?.name ?? null,
    materialCategory: item?.material?.category ?? "Unknown",
    materialPoint: item?.material?.point ?? 0,
    materialUnit: item?.material?.unit ?? null,
    materialId: item?.material?._id ?? "Unknown",
    quantity: item?.quantity ?? 0,
    reason: item?.reason ?? "No reason",
    status:
      item?.status === "A"
        ? "Submitted"
        : item?.status === "AD"
          ? "Amended"
          : item?.status === "P"
            ? "Pending"  // Simplified as both versions had similar handling for 'P'
            : item?.status === "R"
              ? "Queried"
              : "Unknown",
    profId: item?.profile?._id ?? null,
    profileName: item?.profile?.name ?? null,
    dateCreated: item?.create_date ?? null,
    dateUpdated: item?.last_update ?? null,
    date: item?.date ?? null,
  };
};


export const transactionService = {
  addTransactions: async (transactionData) => {
    try {
      console.log("Adding new Transactions:", transactionData);
      const response = await api.post(
        `/mapi/transaction/addTransactions`,
        transactionData
      );
      return response.data;
    } catch (error) {
      console.error(
        "Error adding new Transactions:",
        error.response?.data || error.message
      );
      throw error;
    }
  },

  getTransactions: async (
    entityId = null,
    profileId = null,
    startDate = null,
    endDate = null
  ) => {
    try {
      const params = new URLSearchParams();
      if (entityId) params.append("EntityId", entityId);
      if (profileId) params.append("ProfileId", profileId);

      // Add both dates if they exist
      if (startDate) params.append("StartDate", startDate);
      if (endDate) params.append("EndDate", endDate);

      console.log("Final API params:", params.toString());
      const response = await api.get(`/mapi/transaction/getTransaction`, {
        params,
      });
      console.log("Service received dates:", { startDate, endDate });
      console.log("Params being sent:", params.toString());
      console.log("api response: ", response.data);

      return response.data;
    } catch (error) {
      console.error(
        "Error fetching transactions:",
        error.response?.data || error.message
      );
      throw error;
    }
  },

  editTransaction: async (transactionData) => {
    try {
      console.log("Editing Transaction:", transactionData);
      const response = await api.post(
        `/mapi/transaction/editTransaction`,
        transactionData
      );
      return response.data;
    } catch (error) {
      console.error(
        "Error editing transaction:",
        error.response?.data || error.message
      );
      throw error;
    }
  },
};

export default transactionService;
